/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCustomPublishingChannelEdit = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M18 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm1-3a3 3 0 0 0-2.704 4.301L14.597 8H9.403l-1.7-1.699a3 3 0 1 0-1.418 1.41L8 9.426v5.148L6.286 16.29a3 3 0 1 0 1.418 1.41L9.403 16h2.354l2-2H10v-4h4v3.757l2-2V9.426l1.714-1.715A3 3 0 1 0 19 2zM4 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm0 14a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm14.293-6.707a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414L17.414 22H13v-4.414zM15 18.414V20h1.586l4-4L19 14.414z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCustomPublishingChannelEdit as CustomPublishingChannelEdit };
